import { render, staticRenderFns } from "./AdminProductList.vue?vue&type=template&id=d27379cc&scoped=true"
import script from "./AdminProductList.vue?vue&type=script&lang=js"
export * from "./AdminProductList.vue?vue&type=script&lang=js"
import style0 from "./AdminProductList.vue?vue&type=style&index=0&id=d27379cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d27379cc",
  null
  
)

export default component.exports